module.exports = __webpack_public_path__ + "img/BOWTIE 1 GREEN.7b3a96b.svg";